"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InStorageCache = void 0;

var _apolloCacheInmemory = require("apollo-cache-inmemory");

var _objectStorageCache = require("./objectStorageCache");

var _transform = require("./transform");

var _utils = require("./utils");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var defaults = {
  normalize: _utils.normalize,
  denormalize: _utils.denormalize
};

var InStorageCache =
/*#__PURE__*/
function (_InMemoryCache) {
  _inherits(InStorageCache, _InMemoryCache);

  /**
   * @property {(Object|Function)} storage - The Storage to use.
   *
   * @see https://www.w3.org/TR/webstorage/#storage
   */

  /**
   * @property {Function} [normalize] - Normalization callback. Executed
   * prior to storing a resource.
   */

  /**
   * @property {Function} [denormalize] - Denormalization callback. Executed
   * after retrieving a cached resource from the storage.
   */

  /**
   * @property {Function} [shouldPersist] - Callback to determine if a given
   * data should be cached.
   */

  /**
   * @property {boolean} [addPersistField] - Whether or not should add a
   * __persist field to all non scalar types in a query.
   */

  /**
   * @property {string} [prefix] - The prefix to use when saving to the
   * provided storage. Useful to diff items from this and other persisting
   * systems that share the same storage.
   */
  function InStorageCache() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        storage = _ref.storage,
        _ref$normalize = _ref.normalize,
        normalize = _ref$normalize === void 0 ? defaults.normalize : _ref$normalize,
        _ref$denormalize = _ref.denormalize,
        denormalize = _ref$denormalize === void 0 ? defaults.denormalize : _ref$denormalize,
        _ref$shouldPersist = _ref.shouldPersist,
        shouldPersist = _ref$shouldPersist === void 0 ? function () {
      return true;
    } : _ref$shouldPersist,
        _ref$addPersistField = _ref.addPersistField,
        addPersistField = _ref$addPersistField === void 0 ? false : _ref$addPersistField,
        _ref$prefix = _ref.prefix,
        prefix = _ref$prefix === void 0 ? '' : _ref$prefix,
        config = _objectWithoutProperties(_ref, ["storage", "normalize", "denormalize", "shouldPersist", "addPersistField", "prefix"]);

    _classCallCheck(this, InStorageCache);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InStorageCache).call(this, config));

    _defineProperty(_assertThisInitialized(_this), "storage", void 0);

    _defineProperty(_assertThisInitialized(_this), "normalize", void 0);

    _defineProperty(_assertThisInitialized(_this), "denormalize", void 0);

    _defineProperty(_assertThisInitialized(_this), "shouldPersist", void 0);

    _defineProperty(_assertThisInitialized(_this), "addPersistField", void 0);

    _defineProperty(_assertThisInitialized(_this), "prefix", void 0);

    if (!storage) {
      throw new _utils.InStorageCacheError('You must provide a storage to use');
    }

    if (!(0, _utils.validStorage)(storage)) {
      throw new _utils.InStorageCacheError('You must provide a valid storage to use');
    }

    _this.addPersistField = typeof addPersistField === 'function' ? addPersistField : function () {
      return addPersistField;
    };
    _this.persistence = {
      storage: storage,
      normalize: normalize,
      denormalize: denormalize,
      shouldPersist: shouldPersist,
      prefix: prefix
    };
    _this.data = new _objectStorageCache.ObjectStorageCache(null, _this.persistence);
    _this.optimisticData = _this.data;
    return _this;
  }

  _createClass(InStorageCache, [{
    key: "transformDocument",
    value: function transformDocument(doc) {
      return _get(_getPrototypeOf(InStorageCache.prototype), "transformDocument", this).call(this, this.addPersistField(doc) ? (0, _transform.addPersistFieldToDocument)(doc) : doc);
    }
  }]);

  return InStorageCache;
}(_apolloCacheInmemory.InMemoryCache);

exports.InStorageCache = InStorageCache;